import { useQuery } from "@tanstack/react-query"

import { getMedicos } from "../services/medicos.service";

export const useMedicos = ({ searchString: search, searchLimite: limite, searchPag: pag }) => {

    const medicosQuery = useQuery({
        queryKey: ['medicos', { pag, limite, search }],
        queryFn: () => getMedicos(pag, limite, search),
        staleTime: 1000 * 60, // 1 min
        placeholderData: {
            desde: 0,
            hasta: 0,
            limite_por_pagina: 5,
            medicos: [],
            pagina: 0,
            total: 0,
            total_paginas: 0
        }
    });

    return {
        medicosQuery,
    }
}